/** Hash route of a target's detail view; a link, so it also works from the keyboard and in new tabs. */
export const detailHref = (target: string) => `#/target/${encodeURIComponent(target)}`;
